<template>
  <div :class="label ? null : $attrs.class">
    <label v-if="label" class="form-label" :for="selectId">{{ label }}:</label>
    <select
      :id="selectId"
      :value="modelValue ?? ''"
      :disabled="disabled"
      :required="required"
      class="form-select"
      :class="[
        label ? $attrs.class : null,
        compact ? 'py-1.5 text-sm' : null,
        {
          error: errors.length,
          'border-amber-500 text-amber-700 focus:border-amber-500': isBlankHighlighted,
        },
      ]"
      @mousedown.stop
      @click.stop
      @change="onChange"
    >
      <option v-if="allowBlank" value="">
        {{ blankLabel }}
      </option>
      <option
        v-for="option in optionsList"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <div v-if="errors.length" class="form-error">
      {{ errors[0] }}
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

const DEFAULT_OPTIONS = [{ value: 'code_medical_center', label: 'Centrum Medyczne CODE' }];

export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    allowBlank: {
      type: Boolean,
      default: false,
    },
    blankLabel: {
      type: String,
      default: '—',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    highlightWhenBlank: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      generatedId: this.id || `site-context-select-${uuid()}`,
    };
  },
  computed: {
    selectId() {
      return this.id || this.generatedId;
    },
    optionsList() {
      return this.options.length ? this.options : DEFAULT_OPTIONS;
    },
    isBlankHighlighted() {
      return this.highlightWhenBlank && this.allowBlank && !this.modelValue;
    },
  },
  methods: {
    onChange(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value === '' ? null : value);
    },
  },
};
</script>
